import api from '~/api'

let scopesLoadedResolveFn
const loadedPromise = new Promise(resolve => {
  scopesLoadedResolveFn = resolve
})

const state = () => {
  return {
    provider: {},
    permissions: [],
    roles: [],
    loadedPromise,
  }
}

const getters = {
  providerId: s => s.provider.id,
  isSuperAdmin: s => s.roles.some(role => role === 'ch:admin'),

  hasPermission: s => key => s.permissions.indexOf(key) !== -1,

  canReadProvider: s => s.permissions.includes('provider:read'),
  canSearchProvider: s => !s.provider.id,
  canCreateProvider: s => s.permissions.includes('provider:create'),
  canUpdateProvider: s => s.permissions.includes('provider:update'),
  canDeleteProvider: s => s.permissions.includes('provider:delete'),
  canSwitchProvider: s => s.permissions.includes('provider:switch'),

  canReadRetailer: s => s.permissions.includes('retailer:read'),
  canCreateRetailer: s => s.permissions.includes('retailer:create'),
  canUpdateRetailer: s => s.permissions.includes('retailer:update'),
  canDeleteRetailer: s => s.permissions.includes('retailer:delete'),

  canReadOffer: s => s.permissions.includes('offer:read'),
  canCreateOffer: s => s.permissions.includes('offer:create'),
  canUpdateOffer: s => s.permissions.includes('offer:update'),
  canDeleteOffer: s => s.permissions.includes('offer:delete'),

  canReadCategory: s => s.permissions.includes('category:read'),
  canCreateCategory: s => s.permissions.includes('category:create'),
  canUpdateCategory: s => s.permissions.includes('category:update'),
  canDeleteCategory: s => s.permissions.includes('category:delete'),

  canCreateApiKey: s => s.permissions.includes('api_key:create'),
  canDeleteApiKey: s => s.permissions.includes('api_key:delete'),
  canReadApiKey: s => s.permissions.includes('api_key:read'),
  canUpdateApiKey: s => s.permissions.includes('api_key:update'),
}

const mutations = {
  SET_ME(state, { provider = {}, permissions = [], roles = [] }) {
    state.provider = provider
    state.permissions = permissions
    state.roles = roles
  },
}

const actions = {
  async GET_ME({ state, commit, dispatch }, { providerId }) {
    const [error, me] = await api.get('/me')

    if (error) {
      console.error(error)
      return
    }

    let provider = { id: providerId || null }

    if (providerId) {
      const [error, response] = await dispatch('providers/GET_PROVIDER', providerId, { root: true })

      if (!error) {
        provider = response
      }
    }

    commit('SET_ME', {
      provider,
      ...me,
    })

    scopesLoadedResolveFn()
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
